var moneyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});
function documentReady(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}
function getParameterByName(b) {
    b = b.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var a = "[\\?&]" + b + "=([^&#]*)";
    var d = new RegExp(a);
    var c = d.exec(window.location.search);
    if (c == null) {
        return ""
    } else {
        return decodeURIComponent(c[1].replace(/\+/g, " "))
    }
}

var currentQuoteInfo = null;

function getQuoteI18n() {
    return window.SEQuoteI18n || {};
}

function isQuoteExpired(quoteinfor) {
    if (!quoteinfor) {
        return false;
    }
    if (quoteinfor.Status && quoteinfor.Status.toUpperCase() === 'EXPIRED') {
        return true;
    }
    if (!quoteinfor.ValidDate) {
        return false;
    }
    var validThrough = new Date(quoteinfor.ValidDate);
    if (isNaN(validThrough.getTime())) {
        return false;
    }
    validThrough.setHours(23, 59, 59, 999);
    return new Date() > validThrough;
}

function getTeamSalesContact() {
    var i18n = getQuoteI18n();
    return {
        email: i18n.expiredTeamEmail || 'teams@swimoutlet.com',
        phone: i18n.expiredTeamPhone || '800-469-7132'
    };
}

function getSalesRepContact(quoteinfor) {
    var team = getTeamSalesContact();
    if (!quoteinfor) {
        return { name: '', email: team.email, phone: team.phone };
    }
    return {
        name: quoteinfor.s_custbody_ava_salesresp || quoteinfor.SalesRepName || '',
        email: team.email,
        phone: team.phone
    };
}

function hideApprovalControls() {
    var actionQuote = document.querySelector('.quotepage-btn');
    if (actionQuote && actionQuote.parentNode) {
        actionQuote.parentNode.removeChild(actionQuote);
    }
    var emailRequired = document.getElementById('email-required');
    if (emailRequired && emailRequired.parentNode) {
        emailRequired.parentNode.removeChild(emailRequired);
    }
    var divider = document.querySelector('.quote-approve hr.divider');
    if (divider && divider.parentNode) {
        divider.parentNode.removeChild(divider);
    }
}

function showExpiredQuoteModal(quoteinfor) {
    var modal = document.getElementById('quote-expired-modal');
    var overlay = document.getElementById('quote-expired-modal-overlay');
    if (!modal) {
        return;
    }
    var i18n = getQuoteI18n();
    var rep = getSalesRepContact(quoteinfor);
    var titleEl = modal.querySelector('.quote-expired-modal__title');
    var bodyEl = modal.querySelector('.quote-expired-modal__body');
    var repLabelEl = modal.querySelector('.quote-expired-modal__rep-label');
    var repNameEl = modal.querySelector('.quote-expired-modal__rep-name');
    var repEmailEl = modal.querySelector('.quote-expired-modal__rep-email');
    var repPhoneEl = modal.querySelector('.quote-expired-modal__rep-phone');
    var okBtn = modal.querySelector('.quote-expired-modal__ok');

    if (titleEl) {
        titleEl.textContent = i18n.expiredTitle || 'This Quote Has Expired';
    }
    if (bodyEl) {
        bodyEl.textContent = i18n.expiredBody || 'This quote is no longer valid. Please contact your sales representative to request an updated quote.';
    }
    if (repLabelEl) {
        repLabelEl.textContent = i18n.expiredRepLabel || 'Your Sales Representative';
    }
    if (repNameEl) {
        repNameEl.textContent = rep.name || '';
        repNameEl.style.display = rep.name ? '' : 'none';
    }
    if (repEmailEl) {
        if (rep.email) {
            repEmailEl.innerHTML = (i18n.expiredRepEmailLabel || 'Email') + ': <a href="mailto:' + rep.email + '">' + rep.email + '</a>';
            repEmailEl.style.display = '';
        } else {
            repEmailEl.textContent = '';
            repEmailEl.style.display = 'none';
        }
    }
    if (repPhoneEl) {
        if (rep.phone) {
            repPhoneEl.textContent = (i18n.expiredRepPhoneLabel || 'Phone') + ': ' + rep.phone;
            repPhoneEl.style.display = '';
        } else {
            repPhoneEl.textContent = '';
            repPhoneEl.style.display = 'none';
        }
    }
    if (okBtn) {
        okBtn.textContent = i18n.expiredOkButton || 'OK';
    }

    modal.style.display = 'block';
    modal.classList.add('d-block');
    if (overlay) {
        overlay.classList.add('d-block');
    }
}

function hideExpiredQuoteModal() {
    var modal = document.getElementById('quote-expired-modal');
    var overlay = document.getElementById('quote-expired-modal-overlay');
    if (modal) {
        modal.style.display = 'none';
        modal.classList.remove('d-block');
    }
    if (overlay) {
        overlay.classList.remove('d-block');
    }
}

function handleExpiredQuoteUI(quoteinfor) {
    var i18n = getQuoteI18n();
    document.querySelectorAll('.quotemessage').forEach(function(el) {
        el.textContent = i18n.expiredHeaderMessage || 'This quote has expired and is no longer valid. Please contact your sales representative for an updated quote.';
    });
    hideApprovalControls();
    showExpiredQuoteModal(quoteinfor);
}

function setupExpiredQuoteModalClose() {
    var modal = document.getElementById('quote-expired-modal');
    if (!modal) {
        return;
    }
    var okBtn = modal.querySelector('.quote-expired-modal__ok');
    if (okBtn) {
        okBtn.addEventListener('click', function() {
            hideExpiredQuoteModal();
        });
    }
}

/** Prefill PO via SO API (n8n webhook stays server-side). */
function syncQuotePoFromTray(quoteObj) {
    var poInput = document.getElementById("input-pnumber");
    if (!poInput || !quoteObj || !quoteObj.quoteinfor) {
        return;
    }
    var info = quoteObj.quoteinfor;
    var quoteid = info.QuoteID;

    if (quoteid) {
        getApiToken()
            .then(function (my_token) {
                if (!my_token) {
                    throw new Error('Missing API token');
                }
                var url = SEEndpointURL + 'api/n8n/quote/otherrefnum?key=' + Math.random();
                return fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'apikey': my_token,
                        'apitoken': my_token
                    },
                    body: JSON.stringify({ quoteid: quoteid })
                });
            })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(function (data) {
                var metaOk = !data || !data.Meta || data.Meta.StatusCode == "200" || data.Meta.StatusCode === 200;
                var payload = data && data.Data ? data.Data : data;
                if (metaOk && payload && payload.otherrefnum != null) {
                    poInput.value = payload.otherrefnum;
                    return;
                }
                poInput.value = info.OtherRefNum || info.otherrefnum || '';
            })
            .catch(function (error) {
                console.error('Fetch error:', error);
                poInput.value = info.OtherRefNum || info.otherrefnum || '';
            });
    } else {
        poInput.value = info.OtherRefNum || info.otherrefnum || '';
    }
}

function getApiToken() {
    return new Promise((resolve, reject) => {
        let apiKey = Cookies.get('apikey');
        if (apiKey) {
            if (apiKey.startsWith('"')) {
                apiKey = JSON.parse(apiKey);
            }
            resolve(apiKey);
            return;
        }

        var url = SEEndpointURL + 'api/token?key=' + Math.random();
        fetch(url)
            .then(
                function(response) {
                    if (response.status !== 200) {
                        console.log('Looks like there was a problem with apikey-generator(). Status Code: ' + response.status);
                        return;
                    }
                    response.json().then(function(data) {

                        Cookies.set('apikey', data, { expires: 7, path: '/', secure: true })
                        resolve(data);
                    });
                }
            )
            .catch(reject);

    });
}

function showValidateModal(message) {
    var modal = document.getElementById('modal-validate');
    var overlay = document.getElementById('semodal-modal-overlay');
    if (modal) {
        modal.classList.add('d-block');
        if (overlay) overlay.classList.add('d-block');
        // Set message if provided
        var body = modal.querySelector('.modal-body p');
        if (body && message) {
            body.textContent = message;
        }
    }
}

function hideValidateModal() {
    var modal = document.getElementById('modal-validate');
    var overlay = document.getElementById('semodal-modal-overlay');
    if (modal) {
        modal.classList.remove('d-block');
        if (overlay) overlay.classList.remove('d-block');
    }
}

// Add event listener to Close button after DOM is ready
function setupValidateModalClose() {
    var modal = document.getElementById('modal-validate');
    if (modal) {
        var closeBtn = modal.querySelector('.modal-footer .btn.btn-primary');
        if (closeBtn) {
            closeBtn.addEventListener('click', function() {
                hideValidateModal();
            });
        }
    }
}

function validateApprover(){
    if (currentQuoteInfo && isQuoteExpired(currentQuoteInfo)) {
        showExpiredQuoteModal(currentQuoteInfo);
        return;
    }
    if (document.querySelector(".approveremail").value) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,10})$/;
        if (!regex.test(document.querySelector(".approveremail").value)) {
            // alert('Please input a valid email address.');
            showValidateModal('Please input a valid email address.');
            return;
        }
    }else{
        // alert('Please input your email to validate.');
        showValidateModal('Please input your email to validate.');
        return;
    }
    if(!document.getElementById("input-pnumber").value.trim()){
        document.getElementById('missing-po-number').style.display = 'block';
        document.getElementById("input-pnumber").style.border = '1px solid red';
        return;
    }
    if (quoteToken){
        getApiToken()
            .then(my_token => {
                if (my_token != "") {
                    var myData = {
                        'QuoteLink': quoteToken,
                        'ApprovedByEmail':document.getElementById("input-email").value,
                        'Action':'VALIDATE'
                    };
                    
                    var url = SEEndpointURL + 'api/order/quotevalidateadmin?key=' + Math.random();
                    //var url = 'http://localhost:50001/' + 'api/order/quotevalidateadmin?key=' + Math.random();
                    fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'apitoken': my_token
                            },
                            body: JSON.stringify(myData),
                        })
                        .then(
                            function(response) {
                                if (response.status == 400) { // Bad request
                                    showValidateModal('Looks like there was a problem with authentication. Status Code: ' + response.status);
                                    Cookies.remove("apitoken"); //clean to reset 
                                    return;
                                }
                            
                                response.json().then(function(_data) {
                                    if (_data.Meta.StatusCode == "401") { 
                                        showValidateModal('You are not authorized to approve this quote. Please contact the quote owner.');
                                        document.querySelector(".actionquote .approvequote").classList.add('disabled');
                                        document.getElementById("approvaltoken").value = '';
                                        return;
                                    }

                                    if (_data.Meta.StatusCode == "200") { 
                                        console.log('Success');
                                        document.querySelector('#approvedemail').value = document.querySelector(".approveremail").value;
                                        document.querySelector(".approveremail").setAttribute("disabled", true);
                                        document.querySelector(".actionquote .approvequote").classList.remove('disabled');
                                        document.querySelector(".actionquote .approvequote").removeAttribute("disabled");

                                        document.querySelector(".validateapprover").setAttribute("disabled", true);
                                        document.getElementById("approvaltoken").value = _data.Data;

                                    } 
                                });

                                
                            }
                        )
                        .catch(function(err) {
                            console.log('Fetch Error :-S', err);
                        });

                        
                }

            }).catch(err => {
                console.log("Error when getting API key " + err);
            });
    }
}

function confirmQuote(action){
    if (currentQuoteInfo && isQuoteExpired(currentQuoteInfo)) {
        showExpiredQuoteModal(currentQuoteInfo);
        return;
    }
    if(!document.getElementById("approvaltoken").value){
        showValidateModal('Please input your email to validate.');
        return;
    }
    if(!document.getElementById("input-pnumber").value.trim()){
        document.getElementById('missing-po-number').style.display = 'block';
        document.getElementById("input-pnumber").style.border = '2px solid red';
        return;
    }
    if (confirm('Do you want to ' + action + ' the quote?')){
        if (quoteToken){
            getApiToken()
                .then(my_token => {
                    if (my_token != "") {
                        if(action=='APPROVE'){
                            document.querySelector(".actionquote .approvequote").style.opacity = "0.5";
                        }
                        if(action=='DENY'){
                            document.querySelector(".actionquote .denyquote").style.opacity = "0.5";
                        }

                        var trayPayload = {
                            "po": document.getElementById("input-pnumber").value.trim(),
                            "quoteid": document.getElementById("quotetranid").textContent
                        };
                        console.log(trayPayload);

                        fetch(SEEndpointURL + 'api/n8n/quote/updatepo?key=' + Math.random(), {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'apikey': my_token,
                                    'apitoken': my_token
                                },
                                body: JSON.stringify(trayPayload)
                            })
                            .catch(function (error) {
                                console.error('n8n update PO error:', error);
                            });

                        var myData = {
                            'QuoteLink': quoteToken,
                            'ApprovalToken':document.getElementById("approvaltoken").value,
                            'ApprovedByEmail':document.querySelector('#approvedemail').value,
                            'DraftOrderId':document.getElementById("draftorderid").value,
                            'Action':action
                        };

                        var url = SEEndpointURL + 'api/order/confirmquotewithtoken?key=' + Math.random();
                        //var url = 'http://localhost:50001/' + 'api/order/confirmquotewithtoken?key=' + Math.random();
                        fetch(url, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'apitoken': my_token
                                },
                                body: JSON.stringify(myData),
                            })
                            .then(response => {
                                if (!response) {
                                    return null;
                                }
                                if (response.status == 400) { // Bad request
                                    console.log('Looks like there was a problem with authentication. Status Code: ' +
                                        response.status);
                                    Cookies.remove("apitoken"); //clean to reset 
                                    return null;
                                }

                                return response.json();
                            })
                            .then(_data => {
                                if (!_data) {
                                    return;
                                }

                                if (_data.Meta.StatusCode == "200") { 
                                    console.log('Success');

                                    var temp = document.querySelector('.actionquote');//remove btn
                                    temp.parentNode.removeChild(temp);

                                    if(action=='APPROVE'){
                                        if(_data.Data){
                                            document.getElementById("newordername").textContent = _data.Data;
                                        }else{
                                            document.querySelector('.quote-msg-confirm-content').textContent='Something wrong, the order is not created. Please contact the Sale team. Thank you !';
                                        }
                                        document.getElementById("quote-msg-confirm").style.display = 'block';
                                    }
                                    if(action=='DENY'){
                                        //document.querySelector('.quotemessage').textContent='The quote has been denied, please contact us for future requests. Thank you !';
                                        document.getElementById("quote-msg-confirm").style.display = 'block';
                                    }

                                    //document.querySelector(".quotecontent").style.display = 'block'
                                } else {
                                    document.querySelector('.quote-msg-confirm-content').textContent='Something wrong, the order is not created. Please contact the Sale team. Thank you !';
                                    document.getElementById("quote-msg-confirm").style.display = 'block';
                                }
                                document.querySelector('.quote-approved').style.display = 'block';
                                document.querySelector('.quote-denied').style.display = 'none';
                            })
                            .catch(error => console.error('Fetch error:', error));
                    }

                }).catch(err => {
                    console.log("Error when getting API key " + err);
                });
        }
    }
}

function loadQuote() {
    if (quoteToken) {
        getApiToken()
            .then(my_token => {
                if (my_token != "") {
                    var myData = {
                        'QuoteLink': quoteToken
                        
                    };
                    
                    var url = SEEndpointURL + 'api/order/quoteload?key=' + Math.random();
                    fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'apitoken': my_token
                            },
                            body: JSON.stringify(myData),
                        })
                        .then(
                            function(response) {
                                if (response.status == 400) { // Bad request
                                    console.log('Looks like there was a problem with authentication. Status Code: ' +
                                        response.status);
                                    Cookies.remove("apitoken"); //clean to reset 
                                    return;
                                }
                              
                                response.json().then(function(_data) {
                                    
                                    var statusCode = _data.Meta && _data.Meta.StatusCode;
                                    var isOk = statusCode == "200" || statusCode === 200;
                                    if (isOk) { 
                                        console.log('Success');
                                        var quoteObj = JSON.parse(_data.Data);
                                        currentQuoteInfo = quoteObj.quoteinfor;
                                        syncQuotePoFromTray(quoteObj);
                                        if(quoteObj.quoteinfor.Status=='DENIED'){
                                            document.querySelector('.quotemessage').textContent='The quote is denied, please contact us for future requests. Thank you !';
                                        }
                                        if(quoteObj.quoteinfor.Status=='CLOSED' || quoteObj.quoteinfor.Status=='DEPRECATED'){
                                            document.querySelector('.quotemessage').textContent="The quote was closed, please check again if there's a newer quote. Thank you !";
                                        }
                                        if(quoteObj.quoteinfor.Status=='APPROVED'){
                                            document.querySelector('.quotemessage').textContent='The quote is approved. Thank you !';
                                        }
                                        
                                        document.getElementById("quotetranid").textContent = quoteObj.quoteinfor.s_EstimatedNo;
                                        document.getElementById("quotedate").textContent = new Date(quoteObj.quoteinfor.CreatedAt).toLocaleDateString('en-US');
                                        document.getElementById("quote_expired_date").textContent = new Date(quoteObj.quoteinfor.ValidDate).toLocaleDateString('en-US');
                                        // document.getElementById("fullname").textContent = quoteObj.quoteinfor.FullName;
                                        // document.getElementById("phonenumber").textContent = quoteObj.quoteinfor.PhoneNumber;
                                        // document.getElementById("faxnumber").textContent = quoteObj.quoteinfor.FaxNumber;

                                        // document.getElementById("emailaddress").textContent = quoteObj.quoteinfor.Email;
                                        document.getElementById("billingaddress").innerHTML = (quoteObj.quoteinfor.BillingAddress || '').replace(/\n/g, "<br>");;
                                        document.getElementById("shippingaddress").innerHTML = (quoteObj.quoteinfor.ShippingAddress || '').replace(/\n/g, "<br>");;;
                                        document.getElementById("salerep").textContent = quoteObj.quoteinfor.s_custbody_ava_salesresp;
                                        document.getElementById("shippingmethod").textContent = quoteObj.quoteinfor.ShippingMethod;
                                        

                                        //document.getElementById("lb_Subtotal").textContent = moneyFormatter.format(quoteObj.quoteinfor.SubTotalPrice);
                                        document.getElementById("lb_Tax").textContent = moneyFormatter.format(quoteObj.quoteinfor.TotalTax);
                                        document.getElementById("lb_Shipping").textContent = moneyFormatter.format(quoteObj.quoteinfor.Shipping);
                                        document.querySelectorAll(".lb_Total").forEach(lb_Total =>{ 
                                            lb_Total.textContent = moneyFormatter.format(quoteObj.quoteinfor.QuoteAmount);
                                          });
                                        document.getElementById("draftorderid").value = quoteObj.quoteinfor.DraftOrderID;

                                        var quoteExpired = isQuoteExpired(quoteObj.quoteinfor);
                                        if (quoteExpired) {
                                            handleExpiredQuoteUI(quoteObj.quoteinfor);
                                        } else if(quoteObj.quoteinfor.Status && quoteObj.quoteinfor.Status.toLowerCase()=='open'){
                                            document.querySelector('.quotepage-btn').style.display='';
                                        }else{ // remove btn
                                            var temp = document.querySelector('.quotepage-btn');
                                            temp.parentNode.removeChild(temp);

                                            temp = document.querySelector('#email-required');
                                            temp.parentNode.removeChild(temp);
                                        }
                                        //Quote items detail
                                        var totalDiscount = 0;
                                        var lineDiscount = 0
                                        var orderDiscount = 0
                                        var sumMSRP = 0;
                                        orderDiscount = Math.abs(quoteObj.quoteinfor.ProductDiscount);
                                        var quotedetails = quoteObj.quotedetail || [];
                                        for (let index = 0; index < quotedetails.length; index++) { 
                                            var line = quotedetails[index];
                                            //totalDiscount += line.ProductDiscount;
                                            var eachDiscount = Math.abs(parseFloat(line.ProductDiscount)); //(parseFloat(line.Rate) - parseFloat(line.MSRP)) * parseInt(line.Quantity);
                                            var RateAfterDiscount = parseFloat(line.Rate) - eachDiscount;
                                            var finalLineDiscount = (parseFloat(line.MSRP) - RateAfterDiscount) > 0 ? -(parseFloat(line.MSRP) - RateAfterDiscount) : 0;
                                            sumMSRP += (parseFloat(line.MSRP) * parseInt(line.Quantity));
                                            lineDiscount += (finalLineDiscount * parseInt(line.Quantity));
                                            var htmlDetail = "";
                                            htmlDetail+='<tr>';
                                            htmlDetail+= '<td><p>'+line.ProductCode+'</p></td>';
                                            htmlDetail+= '<td>';
                                            htmlDetail+=        '<p>'+line.ProductName+'</p>';
                                            if(line.ProductOptions){
                                                htmlDetail+=    '<p style="font-size:12px">'+line.ProductOptions+'</p>';
                                            }
                                            htmlDetail+= '</td>';
                                            htmlDetail+= '<td><p>'+line.Quantity+'</p></td>';
                                            //htmlDetail+= '<td><p>'+moneyFormatter.format(line.Rate)+'</p></td>';
                                            //htmlDetail+= '<td><p>'+moneyFormatter.format(line.ItemAmount)+'</p></td>';
                                            htmlDetail+= '<td><p>'+moneyFormatter.format(line.MSRP) +'</p></td>';
                                            htmlDetail+= '<td><p>'+moneyFormatter.format(finalLineDiscount) +'</p></td>';
                                            htmlDetail+= '<td><p>'+moneyFormatter.format(RateAfterDiscount) +'</p></td>';
                                            htmlDetail+= '<td><p>'+moneyFormatter.format(line.ItemAmount)+'</p></td>';
                                            htmlDetail+= '</tr>';
                                            var row = document.getElementById('quotedetaildata').tBodies[0].insertRow(0);

                                            row.innerHTML = htmlDetail;

                                        }
                                        totalDiscount = Math.abs(orderDiscount) + Math.abs(lineDiscount);
                                        document.getElementById("lb_Discount").textContent = "-" + moneyFormatter.format(totalDiscount);
                                        //document.getElementById("lb_Subtotal").textContent = moneyFormatter.format(parseFloat(quoteObj.quoteinfor.SubTotalPrice) + Math.abs(lineDiscount));
                                        document.getElementById("lb_Subtotal").textContent = moneyFormatter.format(sumMSRP);
                                        document.querySelector(".quotecontent").style.display = 'block'

                                        if (!quoteExpired) {
                                            //Auto scrolling at Approver Email
                                            const element = document.querySelector('#anchor-scroll');
                                            if (element) {
                                                setTimeout(() => {
                                                    const offsetTop = window.innerWidth <= 768 ? element.offsetTop - 200 : element.offsetTop - 300;
                                                    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
                                                }, 1000); // Delay of 1000 milliseconds
                                            }
                                        }

                                    } else {
                                      
                                    }
                                });
                            }
                        )
                        .catch(function(err) {
                            console.log('Fetch Error :-S', err);
                        });

                }

            }).catch(err => {
                console.log("Error when getting API key " + err);
            });
    }

}
var quoteToken = getParameterByName('token');
documentReady(function() {
    loadQuote(); 
    setupValidateModalClose();
    setupExpiredQuoteModalClose();
    
    // Add event listener to remove red border when user types in input-pnumber
    var inputPnumber = document.getElementById("input-pnumber");
    if (inputPnumber) {
        inputPnumber.addEventListener('input', function() {
            if (this.value.trim() !== '') {
                this.style.border = '';
                document.getElementById('missing-po-number').style.display = 'none';
            }
        });
    }
});